import featureClient1 from "../clients/buko/feature.json";
import featureClient2 from "../clients/labelle/feature.json";
import featureClient3 from "../clients/pushndrip/feature.json";
import { appConfig } from "./app.config";

export const appFeatureRecord = {
  ["buko"]: featureClient1,
  ["labelle"]: featureClient2,
  ["pushndrip"]: featureClient3,
};
export const appFeature =
  appFeatureRecord[appConfig.client as keyof typeof appFeatureRecord];
